import {
    CORE_LOAD_ALL_ROOMFORMATS_REQUEST,
    CORE_LOAD_ALL_ROOMFORMATS_SUCCESS,

    CORE_LOAD_ROOMFORMAT_REQUEST,
    CORE_LOAD_ROOMFORMAT_SUCCESS,

    CORE_FILTER_ROOMFORMAT_REQUEST,
    CORE_FILTER_ROOMFORMAT_SUCCESS,

} from '../../types'


const initialState = []
export default {
    roomformats: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ALL_ROOMFORMATS_REQUEST:
            case CORE_FILTER_ROOMFORMAT_REQUEST:
                return initialState

            case CORE_LOAD_ALL_ROOMFORMATS_SUCCESS:
            case CORE_FILTER_ROOMFORMAT_SUCCESS:
                if (action.payload[0]) {
                    let payload = action.payload
                    let buildings = []
                    payload.forEach(data => {
                        buildings.push({
                            _id: data._id,
                            name: data.name,
                        })
                    })
                    return buildings
                }
                return action.payload
            default:
                return state
        }
    },
    roomformat: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ROOMFORMAT_REQUEST:
                return initialState

            case CORE_LOAD_ROOMFORMAT_SUCCESS:
                return action.payload
            default:
                return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/features/roomFormat/reducer.js